"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgNewMessage = function SvgNewMessage(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.531H5v-.324l-.297-.132-.204.456Zm0 3.917H4v1.073l.821-.69-.322-.383Zm3.802-3.195-.017-.5-.173.006-.132.111.322.383Zm.772-.06.06.497-.06-.496ZM8 1.759c3.872 0 6.833 2.551 6.833 5.5h1c0-3.68-3.605-6.5-7.833-6.5v1Zm-6.833 5.5c0-2.949 2.96-5.5 6.833-5.5v-1c-4.228 0-7.833 2.82-7.833 6.5h1Zm3.536 4.817c-2.15-.958-3.536-2.785-3.536-4.817h-1c0 2.52 1.713 4.654 4.129 5.73l.407-.913Zm-.704.456v3.917h1V12.53H4Zm.822 4.3 3.802-3.195-.643-.766-3.802 3.195.643.766Zm4.852-4.24c-.216.044-.436.08-.659.107l.12.992c.25-.03.496-.07.738-.119l-.2-.98Zm-.659.107a8.437 8.437 0 0 1-.729.055l.033 1c.276-.01.548-.03.815-.063l-.119-.992Zm5.82-5.44c0 .405-.055.8-.159 1.18l.965.263c.127-.464.193-.947.193-1.443h-1Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.71,
    cy: 12.307,
    fill: "#D0021B",
    r: 2.667
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgNewMessage);
var _default = exports["default"] = Memo;